import { useRef } from 'react';

import { CropPointId } from '@rdTypes/shared';
import { useDraggable } from '@dnd-kit/core';


export interface CropPointProps {
  x: number;
  y: number;
  pointId: CropPointId;
  onDrag: (coordinates: any, pointId: CropPointId) => void;
}

export const CropPoint = ({ x, y, pointId, onDrag: externalOnDrag }: CropPointProps) => {
  const transformRef = useRef({
    x, y
  });

    const {attributes, listeners, setNodeRef, transform} = useDraggable({
    id: pointId,
  });

  if (transform && (transformRef.current.x !== transform?.x || transformRef.current.y !== transform?.y )) {
    transformRef.current = { x: transform.x, y: transform.y };
    externalOnDrag(transformRef.current, pointId);
  }

  return (
      <div
        {...listeners}
        {...attributes}
        style={{
          position: 'absolute',
          top: y,
          left: x,
          zIndex: 7,
        }}
        ref={setNodeRef}
        className={`rd-cropper-point-${pointId}`}
      >
        <div
          style={{
            position: 'absolute',
            top: -15,
            left: -15,
            width: 30,
            height: 30,
            border: '4px solid white',
            borderRadius: '100%',
            cursor: 'grabbing',
          }}
        ></div>
      </div>
  );
};